export default "__VITE_ASSET__f$Tn_pSk__"